import React from "react";
import { TEAL } from "./constants";

function when(iso) {
  if (!iso) return "";
  const then = new Date(iso);
  const mins = Math.round((Date.now() - then.getTime()) / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours} hr ago`;
  return then.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

const exactly = (iso) => (iso ? new Date(iso).toLocaleString() : "");

export default function VersionHistory({
  versions, loading, busyId, onRestore, onSaveVersion, onClose, saving, unavailable,
}) {
  return (
    <div
      className="absolute left-3 bottom-3 z-[60] rounded-xl border border-black/[0.08] shadow-[0_10px_30px_rgba(0,0,0,0.18)] font-['DM_Sans']"
      style={{ background: "#FFFFFF", width: 290, maxHeight: "62%", display: "flex", flexDirection: "column" }}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onDoubleClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-center justify-between px-3 py-2 border-b border-black/[0.06] flex-shrink-0">
        <div>
          <div className="text-[12px] font-bold text-slate-800 leading-none">Version history</div>
          <div className="text-[10px] text-slate-400 pt-[3px] leading-none">Saved snapshots of this board</div>
        </div>
        <button type="button" onClick={onClose} title="Close"
          className="text-slate-400 text-[16px] leading-none bg-transparent border-none cursor-pointer px-1">
          ✕
        </button>
      </div>

      <div className="overflow-y-auto flex-1" style={{ minHeight: 0 }}>
        {unavailable && (
          <p className="text-[12px] text-slate-400 px-3 py-4 m-0 leading-relaxed">
            Versions are saved per room, so this needs a saved board. Draw something first.
          </p>
        )}

        {!unavailable && loading && (
          <p className="text-[12px] text-slate-400 px-3 py-4 m-0">Loading…</p>
        )}

        {!unavailable && !loading && versions.length === 0 && (
          <p className="text-[12px] text-slate-400 px-3 py-4 m-0 leading-relaxed">
            No saved versions yet. Use <strong className="text-slate-500">Save version</strong> below
            to keep a snapshot you can come back to.
          </p>
        )}

        {!unavailable && versions.map((v) => (
          <div key={v.id}
            className="flex items-center gap-2 px-3 py-[9px] border-b border-black/[0.05] last:border-b-0">
            <div className="min-w-0 flex-1">
              <div className="text-[12px] font-semibold text-slate-700 truncate">
                {v.label || "Saved version"}
              </div>
              <div className="text-[10px] text-slate-400" title={exactly(v.created_at)}>
                {when(v.created_at)}
              </div>
            </div>
            <button
              type="button"
              onClick={() => onRestore(v.id)}
              disabled={Boolean(busyId)}
              className="text-[11px] font-semibold px-2 py-[5px] rounded-md cursor-pointer border flex-shrink-0 disabled:opacity-50"
              style={{ color: TEAL, borderColor: "rgba(77,184,181,0.4)", background: "rgba(77,184,181,0.10)" }}
            >
              {busyId === v.id ? "Opening…" : "Restore"}
            </button>
          </div>
        ))}
      </div>

      <div className="flex items-center gap-2 px-3 py-2 border-t border-black/[0.06] flex-shrink-0">
        <button
          type="button"
          onClick={onSaveVersion}
          disabled={saving || unavailable}
          className="text-[11px] font-semibold px-2 py-[5px] rounded-md cursor-pointer border-none text-white disabled:opacity-50"
          style={{ background: TEAL }}
        >
          {saving ? "Saving…" : "Save version"}
        </button>
        <span className="ml-auto text-[10px] text-slate-400">
          {unavailable ? "" : `${versions.length} saved`}
        </span>
      </div>
    </div>
  );
}
